import React, { useEffect, useState } from "react";
import orderSuccess from "../Images/orderSucess.png";
import success2 from "../Images/success2.png";
import failedImage from "../Images/faild.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DotLoader } from "react-spinners";
import { make_accept } from "../../src/store/action/order/order";
import MoyasarPaymentForm from "../Components/PaymentMoyaserForm";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setLanguage } from "../store/action/language/language";

function PaymentCheckMoyasar() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(null);
  const [payAgain, setPayAgain] = useState(false);
  const languageState = useSelector((state) => state.language);
  const language = languageState.lang;

  const searchParams = new URLSearchParams(window.location.search);
  const status = searchParams.get("status");
  const transactionId = searchParams.get("id");
  const amount = searchParams.get("amount")
    ? parseFloat(searchParams.get("amount")) / 100
    : null;

  useEffect(() => {
    const handleLanguage = () => {
      const data = window.localStorage.getItem("LANGUAGE");
      if (data !== null) {
        const { language, x } = JSON.parse(data);
        i18n.changeLanguage(language);
        document.getElementById("root").style.direction = x;
        dispatch(setLanguage(language, x));
      } else {
        // Fallback to Redux state if localStorage is not available
        const lang = languageState.lang || "en";
        const dir = languageState.dir || "ltr";
        i18n.changeLanguage(lang);
        document.getElementById("root").style.direction = dir;
      }
      document.title =
        i18n.language === "ar" ? "مطاعم الرومانسية" : "Al Romansiah Restaurant";
    };
    handleLanguage();
  }, [dispatch, languageState.lang, languageState.dir]);

  useEffect(() => {
    localStorage.removeItem("notes")
    if (status === "paid" && transactionId) {
      const token = JSON.parse(localStorage.getItem("TOKEN"));
      
      // CRITICAL: Validate orderId exists and is recent before processing payment
      const orderId = localStorage.getItem("orderId");
      const orderTimestamp = localStorage.getItem("orderIdTimestamp");
      const sk = localStorage.getItem("sk");
      
      if (!orderId || !sk) {
        console.error("❌ Missing orderId or sk - cannot process payment");
        alert("Payment verification failed. Please contact support.");
        setLoading(false);
        setIsSuccess(false);
        localStorage.removeItem("process");
        return;
      }
      
      // Validate orderId is recent (within last hour)
      if (orderTimestamp) {
        const timestamp = parseInt(orderTimestamp, 10);
        const now = Date.now();
        const oneHour = 60 * 60 * 1000;
        if ((now - timestamp) >= oneHour) {
          console.error("❌ OrderId is stale (older than 1 hour) - cannot process payment");
          alert("Payment verification failed. Order expired. Please try again.");
          setLoading(false);
          setIsSuccess(false);
          localStorage.removeItem("process");
          localStorage.removeItem("orderId");
          localStorage.removeItem("orderIdTimestamp");
          localStorage.removeItem("sk");
          return;
        }
      }
      
      const data = {
        transactionId: transactionId,
        sk: sk
      };
      console.log("Processing payment for orderId:", orderId, "with amount:", amount);

      make_accept(token, JSON.parse(orderId), data)
        .then(() => {
          // localStorage.removeItem("phoneNumber");
          // localStorage.removeItem("TOKEN");
          setIsSuccess(true);
        })
        .catch((e) => {
          setIsSuccess(false);
        })
        .finally(() => {
          setLoading(false);
          localStorage.removeItem("process");
        });
    } else {
      alert("something went wrong")
      setLoading(false);
      setIsSuccess(false);
      localStorage.removeItem("process");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, transactionId]);

  // Handle browser back button - redirect to scan page
  useEffect(() => {
    // Push a new history entry when component mounts
    // This allows us to intercept the back button press
    window.history.pushState({ page: "payment-success" }, "", window.location.href);

    const handlePopState = () => {
      // Immediately push the state back to prevent navigation
      window.history.pushState({ page: "payment-success" }, "", window.location.href);
      
      // Clear all localStorage data
      localStorage.clear();
      
      // Navigate to scan page immediately using window.location for instant navigation
      // This ensures the navigation happens before React Router can process the back navigation
      const baseUrl = window.location.origin;
      window.location.replace(`${baseUrl}/scan`);
    };

    // Add popstate event listener to detect browser back button
    window.addEventListener("popstate", handlePopState);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const handleClose = () => {
    localStorage.clear();
    navigate("/scan");
  };

  const handleInvoice = () => {
    const orderId = localStorage.getItem("orderId");
    const orderQueueId = localStorage.getItem("orderQueueId") || "";

    if (!orderId || !orderQueueId) {
      return;
    }

    const id = `${orderId}-${orderQueueId.substring(1)}`;
    navigate(`/invoice/${id}`);
  };

  const canShowInvoice =
    !!localStorage.getItem("orderId") &&
    !!localStorage.getItem("orderQueueId");

  return (
    <div 
      className="container" 
      style={{ 
        height: "100vh",
        position: "relative",
        ...(isSuccess && !loading ? {
          backgroundImage: `url(${orderSuccess})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        } : {})
      }}
    >
      {isSuccess && !loading && (
        <>
          <div
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
              zIndex: 10
            }}
          >
            <span style={{ fontSize: "24px", color: "#333", fontWeight: "bold" }}>×</span>
          </div>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 5
            }}
          >
            <img
              src={success2}
              alt="Success"
              style={{
                marginBottom: "20px",
                maxWidth: "200px",
                height: "auto"
              }}
            />
            <h2
              style={{
                color: "#333",
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "10px",
                textAlign: "center"
              }}
            >
              {i18n.language === "ar" || language === "ar" 
                ? "تم ارسال طلبك بنجاح" 
                : "Your order has been sent successfully"}
            </h2>
            <p
              style={{
                color: "#666",
                fontSize: "14px",
                textAlign: "center",
                margin: 0
              }}
            >
              {/* {i18n.language === "ar" || language === "ar"
                ? "سيكون النادل في خدمتك خلال لحظات"
                : "The waiter will be at your service in moments"} */}
            </p>
          </div>
          {canShowInvoice && (
            <div
              className={
                language === "ar" || language === "ur"
                  ? "orderBtns"
                  : "orderBtnsEn"
              }
              style={{
                position: "absolute",
                bottom: "30px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 5,
              }}
            >
              <Link to="/menu/meals">
                <button>{t("Basket.orderBtn")}</button>
              </Link>
              <button className="invoiceBtn" onClick={handleInvoice}>
                {t("Basket.invoice")}
              </button>
            </div>
          )}
        </>
      )}
      {loading ? (
        <div className="loader">
          <DotLoader color={"#E57200"} size={50} />
        </div>
      ) : (
        !isSuccess && (
          <div className="orderRec" style={{ padding: "1em" }}>
            <div className="shareForm flex justify-center items-center flex-col">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={failedImage}
                  alt="Failed"
                  style={{ marginBottom: "1em", width: "150px" }}
                />
                <p style={{ color: "rgb(99, 50, 53)", fontSize: "18px" }}>
                  {t("payment.notSuccess_payment")}
                </p>
              </div>
              <>
                <Link to="/menu/meals">
                  <button style={{ marginTop: "10px" }}>
                    {t("Basket.orderBtn")}{" "}
                  </button>
                </Link>
                <div
                  onClick={() => setPayAgain(true)}
                  style={{ marginTop: "10px" }}
                >
                  <button>{t("payAgain")}</button>
                </div>
              </>
            </div>
          </div>
        )
      )}

      {payAgain && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered "
            style={{
              marginTop: "120px",
              minWidth: "70%",
              marginLeft: "20%",
              marginRight: "20%",
            }}
          >
            <div
              className="modal-content"
              style={{ maxWidth: "600px", margin: "auto" }}
            >
              <div className="modal-body">
                <MoyasarPaymentForm
                  amount={amount}
                  description={`AlRomansiah QR Order ORD_${localStorage.getItem("orderId")}`}
                  onSubmit={() => Promise.resolve(true)}
                />
              </div>
              <div
                className="modal-footer"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <button
                  className="btn btn-secondary"
                  onClick={() => setPayAgain(false)}
                >
                  {t("close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PaymentCheckMoyasar;
